import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        _grey: '#737373',
        _blue: '#007EAE',
        _light_grey: '#EEEEEE',
        _deep_blue: '#002D5D',
      },
    },
  },
});
